import apiUrl from '../../../helpers/apiUrl';
import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';

export const getFertilizersGardenRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-fertilizers`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

export const updateFertilizerGardenRequest = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/garden-fertilizers/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const getSpecificFertilizerGardenRequest = async (
  id: string
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-fertilizers/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const createFertilizersGardenRequest = async (data: {
  isActive?: boolean;
  name: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/garden-fertilizers`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: any) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danej nazwie już istnieje');
      } else {
        message.success('Pozytywnie utworzono');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const removeSpecificFertilizersGardenRequest = async (
  idNews: number
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/garden-fertilizers/${idNews}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

export const getGardenFertilizerDictionaryRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-fertilizers/dictionary`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

export const getSpecificGardenFertilizerDictionaryRequest = async (
  id: string
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/garden-fertilizers/dictionary/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const updateGardenFertilizerDictionaryRequest = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/garden-fertilizers/dictionary/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const removeSpecificGardenDictionaryRequest = async (
  id: number
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/garden-fertilizers/dictionary/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};
